import type { AnalyticsQueryRow } from "@/lib/api";
import { cn } from "@/lib/formatters";

interface TopQueriesTableProps {
  rows: AnalyticsQueryRow[];
  limit?: number;
}

function posColor(pos: number): string {
  if (pos <= 10) return "text-success";
  if (pos <= 20) return "text-primary";
  if (pos <= 30) return "text-warn";
  return "text-muted";
}

export function TopQueriesTable({ rows, limit = 10 }: TopQueriesTableProps) {
  const shown = rows.slice(0, limit);

  return (
    <div className="surface overflow-hidden">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <p className="path-chip">top queries</p>
        <span className="font-mono text-xs text-muted">
          {shown.length}/{rows.length}
        </span>
      </div>
      {shown.length === 0 ? (
        <p className="p-6 text-center font-mono text-sm text-muted">$ no queries</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-bg-elev/40 border-b border-border">
            <tr className="text-left text-xs font-mono uppercase tracking-wider text-muted">
              <th className="px-3 py-2">query</th>
              <th className="px-2 py-2 text-right">clk</th>
              <th className="px-2 py-2 text-right">imp</th>
              <th className="px-2 py-2 text-right">pos</th>
            </tr>
          </thead>
          <tbody>
            {shown.map((r) => (
              <tr
                key={r.query}
                className="border-b border-border/40 last:border-0 hover:bg-bg-elev/30 transition-colors"
              >
                <td className="px-3 py-2 truncate max-w-[220px]" title={r.query}>
                  {r.query}
                </td>
                <td className="px-2 py-2 text-right font-mono">{r.clicks}</td>
                <td className="px-2 py-2 text-right font-mono text-muted">{r.impressions}</td>
                <td className={cn("px-2 py-2 text-right font-mono", posColor(r.position))}>
                  {r.position.toFixed(1)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
